module.exports = __webpack_public_path__ + "static/media/IMG_4277.7e54be6a.PNG";